export default __webpack_public_path__ + "static/media/04_Auctioneers-Commercial-EschweilerPhotography_M1A6736.1a1bf230.jpg";